import produce, { Draft } from 'immer';
import { FavouriteQuestionsState } from './_types';
import { initialState } from './_initialState';
import {
    SET_FAVOURITE_QUESTIONS,
    CLEAR_FAVOURITE_QUESTIONS,
} from './_actionTypes';

// * Implements the producer from ImmerJS.
// Notice that it is not needed to handle the default case, a producer that doesn't do anything will simply return the original state.
const favouriteQuestionsReducer = produce(
    (
        draft: Draft<FavouriteQuestionsState> = initialState,
        action
    ): FavouriteQuestionsState => {
        switch (action.type) {
            case SET_FAVOURITE_QUESTIONS:
                draft.favouriteQuestions = action.payload;
                break;
            case CLEAR_FAVOURITE_QUESTIONS:
                draft.favouriteQuestions = initialState.favouriteQuestions;
                break;
        }

        return draft;
    }
);

export default favouriteQuestionsReducer;
